import PropTypes from 'prop-types';

export default {
  selectedRoute: PropTypes.object,
  flights: PropTypes.arrayOf(PropTypes.object),
  departureFlight: PropTypes.object,
  arrivalFlight: PropTypes.object,
  toggleRoutes: PropTypes.func,
  selectedTrip: PropTypes.object,
  toggleTrips: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/containers/flights/desktop/FlightDesktopScreenProps.js